import React from 'react';
import PropTypes from 'prop-types';
import { map, get, groupBy, keyBy, filter } from 'lodash';
import EmptyAddons from './EmptyAddons';
import AddonsHeader from './AddonsHeader';
import AddonsModal from './AddonsModal';
import AddonsBanner from './AddonsBanner';
import ManageAddonsHoc from './hoc';
import Addon from './Addon';

const ManageAddonsMain = ({
  spaces,
  inventory,
  env,
  params,
  openEditAddonModal,
  ...props
}) => {
  const spaceId = params.spaceID || get(spaces, 'data.0._id');
  // filter out concierge items
  const inventoryData = filter(get(inventory, 'data.inventory', []), (item) => {
    return !get(item, 'is_concierge') && item.type !== 'included';
  });

  const groupByCategory = groupBy(inventoryData, 'category');
  const indexAddonEnvById = keyBy(get(env, 'addOns.categories', []), 'id');
  const countries = get(env, 'web.countries', '');
  const currentSpace = filter(get(spaces, 'data'), { _id: spaceId })[0] || {};
  const currencyData = get(countries, `${currentSpace.country}.currencies[0]`, {});

  return (
    <div className="ManageAddons">
      <AddonsHeader
        {...props}
        spaceId={spaceId}
        spaces={spaces}
        inventoryData={inventoryData}
      />
      <div className="ps-container-lg-margin ps-container-fixed">
        <div className="ps-row">
          <div className="col-xs-12">
            {
              inventoryData.length ?
                <div className="inventory-items-container">
                  {
                    map(groupByCategory, (categoryItems, key) => (
                      <div key={key}>
                        <h4>
                          { get(indexAddonEnvById, [key, 'name'], '') }
                        </h4>
                        <div className="clearfix" />
                        <div className="ps-row-nested margin-lg-top">
                          {
                            map(categoryItems, (item) => {
                              return (
                                <div key={item._id} className="col-sm-6">
                                  <Addon
                                    {...props}
                                    item={item}
                                    onClickAction={openEditAddonModal}
                                  />
                                </div>
                              );
                            })
                          }
                        </div>
                      </div>
                    ))
                  }
                </div> :
                <EmptyAddons {...props} />
            }
          </div>
        </div>
      </div>
      <AddonsModal
        {...props}
        spaceId={spaceId}
        currency={currencyData.code || 'USD'}
      />
      <AddonsBanner />
    </div>
  );
};

ManageAddonsMain.propTypes = {
  spaces: PropTypes.object,
  inventory: PropTypes.object,
  env: PropTypes.object,
  params: PropTypes.object,
  toggleModal: PropTypes.func,
  dispatch: PropTypes.func,
  openEditAddonModal: PropTypes.func
};

export default ManageAddonsHoc(ManageAddonsMain);
